import {CommentDiscussionIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasComments, pluralize} from './activity-row-helpers'

export function ReviewCommentsRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasComments(summary)) return null

  const n = summary.comments.count
  const label = `${n} review ${pluralize(n, 'comment', 'comments')}`

  return <SidebarActivityRow icon={CommentDiscussionIcon} label={label} group="comments" expectedCount={n} />
}
